import { Box, Stack } from '@mui/material';
import { NameBanner } from '@rumblefish/ui/Rumblefish23Theme';
import {
  StyledContentWrapper,
  StyledDescription,
  StyledSection,
  StyledStack,
  StyledSubTitle,
  StyledTitle,
} from './styles';
import { whyIsItBetterData } from './WhyIsItBetter.data';

export const WhyIsItBetter = () => {
  return (
    <StyledSection width="small">
      <StyledStack>
        <StyledContentWrapper>
          <Box width="100%" mb={8}>
            <NameBanner
              text="Why Is It Better?"
              type="section"
              color="aquamarine"
            />
          </Box>

          <Stack>
            <StyledTitle variant="display_sm">
              {whyIsItBetterData.title}
            </StyledTitle>
            <StyledSubTitle variant="strong_500">
              {whyIsItBetterData.subTitle}
            </StyledSubTitle>
          </Stack>

          <StyledDescription variant="regular_500">
            {whyIsItBetterData.description}
          </StyledDescription>
        </StyledContentWrapper>
      </StyledStack>
    </StyledSection>
  );
};
